import { getAccessToken } from "@/integrations/cloud/authService";
import { requestCloudApi } from "@/integrations/cloud/cloudApiClient";
import type { CloudIdentity } from "@/integrations/cloud/authService";

export type EntitlementTier = "FREE" | "PRO";

export const fetchEntitlementTier = async (
  identity: CloudIdentity
): Promise<EntitlementTier> => {
  void identity;
  const token = await getAccessToken();
  if (!token) return "FREE";

  const payload = await requestCloudApi<{
    entitlement?: {
      tier?: unknown;
      status?: unknown;
      isActive?: unknown;
      validUntil?: unknown;
    };
  }>("/entitlement", {
    method: "GET",
    headers: {
      authorization: `Bearer ${token}`
    }
  });

  const tier = payload.entitlement?.tier;
  if (tier === "PRO") return "PRO";
  return "FREE";
};
